import React, { useState, useEffect } from "react";
import CreatableSelect from "react-select/creatable";
import Attribute from "views/Accounts/PersonDetails/Attribute";
import "views/Accounts/PersonDetails/personProfileStyle.css";
import { putPersonData, getLabels } from "api/AccountsApi";
import 'bootstrap/dist/css/bootstrap.css';
// import "bootstrap/dist/css/bootstrap.min.css";
// import "bootstrap/dist/js/bootstrap.min.js";

const WorkflowReport = (props) => {
  const [left, setLeft] = useState([]);
  const [right, setRight] = useState([]);

  useEffect(() => {
      if (props.history.location.state && props.history.location.state.length){
        var len = props.history.location.state.length;
        setLeft(props.history.location.state.slice(0, len / 2 + 1));
        setRight(props.history.location.state.slice(len / 2 + 1, len));
      }
     

    }, []);

    return (
        <>
        <button
          className="backBtn btn btn-sm "
          style={{ color: "#114169", marginBottom: '0px' }}
          onClick={() => props.history.push("/admin/workflow/all_workflows")}

        >
          {/* <span>
            {" "}
            <img
              style={{ height: "20px" }}
              src={require("assets/images/back.svg")}
            />
          </span> */}
          <span
            style={{ paddingTop: "1px", marginLeft: "14px"}}
          >
            {`< Back`}
          </span>
        </button>
        <div id="p-container">
          <br />
          <br />

          <h2 className="p-title">Workflow Report </h2>
          <div class="h_line"></div>

        <div style={{ paddingLeft: "30px" }}>
          <div
            className="box"
            style={{ display: "flex", marginLeft: "10px" }}
          >
            
              <div style={{ paddingTop: "1%", paddingLeft: "3%", flex: 1 }}>
            {left.map((obj) => {
                return (
                        <div
        style={{
          display: "flex",
          flexDirection: "row",
          margin: "5px",
          paddingBottom: "20px",
        }}
      >
        <div
          style={{
            width: "50%",
            display: "flex",
            justifyContent: "flex-start",
          }}
        >
          <span className="attributeLabel">{obj.label}</span>
        </div>

                    <div className="valueW attributeValue " style={{ width: '30%'}}>
                      {" "}
                      <span className="attributeLabel" style={{ marginRight: "15px" }}>
                        :
                      </span>{" "}
                      {obj.count}
                    </div>      </div>


                );
            })}
            </div>

              <div style={{ paddingTop: "1%", paddingLeft: "3%", flex: 1 }}>
                {right.map((obj) => {
                  return (
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        margin: "5px",
                        paddingBottom: "20px",
                      }}
                    >
                      <div
                        style={{
                          width: "50%",
                          display: "flex",
                          justifyContent: "flex-start",
                        }}
                      >
                        <span className="attributeLabel">{obj.label}</span>
                      </div>

                      <div className="valueW attributeValue " style={{width:'30%'}}>
                        {" "}
                        <span className="attributeLabel" style={{ marginRight: "15px" }}>
                          :
                        </span>{" "}
                        {obj.count}
                      </div>      </div>
                  );
                })}
              </div>


            </div>
          </div>
        </div>
        </>
    );
};

export default WorkflowReport;
